"use client";
import * as React from "react";
const SvgSavingsRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m14.26 4.84-1.81-1.79q.08-.5.25-.9.14-.32.08-.7C12.68.9 12.1.5 11.52.5c-1.27.02-2.4.64-3.12 1.58h-4A4.37 4.37 0 0 0 0 6.42c0 1.78 1.1 5.9 1.66 7.93a1.6 1.6 0 0 0 1.55 1.15H4.8c.88 0 1.6-.71 1.6-1.58H8c0 .87.72 1.58 1.6 1.58h1.6a1.6 1.6 0 0 0 1.54-1.13l1-3.28 1.72-.57a.8.8 0 0 0 .54-.75V5.63a.8.8 0 0 0-.8-.79zM8 6.03H5.6a.8.8 0 0 1-.8-.8.8.8 0 0 1 .8-.78H8c.44 0 .8.35.8.79s-.36.79-.8.79m3.2 1.58a.8.8 0 1 1 0-1.58c.44 0 .8.35.8.79s-.36.79-.8.79" }));
export {
  SvgSavingsRound as default
};
